
import {mapActions,mapGetters} from "vuex";
import conditionPhone from "@/mixins/conditionPhone";
export default {
	mixins: [conditionPhone],
	props: {
		phone: {
			type: String,
			default: ''
		}
	},
	computed: {
		...mapGetters({
			settings: 'settings/settings/settings'
		}),
	},
	methods: {
		...mapActions({
			openModal: 'modal/modal-main/openModal'
		}),
	},
}
